<template>
  <div class="menu-wrapper">
    <template v-for="(item,index) in menu">
      <!-- 最后一级菜单 -->
	 <el-menu-item
	   v-if="(Array.isArray(item.children) && item.children.length==0) || item.children == null"
	   :key="item.ModuleGuid"
	   :index="item.RoutePath"
	 >
	 	<i class="iconfont fz18 marr8" :class="item.IconName"></i>
	   <span slot="title">{{ item.ShowName }}</span>
	 </el-menu-item>
      <!-- 此菜单下还有子菜单 -->
      <el-submenu
        v-else
        :key="item.ModuleGuid"
        :index="item.KeyName"
      >
        <template slot="title">
        	<i class="iconfont fz18 marr8" :class="item.IconName"></i>
          <span>{{ item.ShowName }}</span>
        </template>
        <!-- 递归 -->
        <sidebar-item
          :menu="item.children"
          :parent="item.RoutePath"
        />
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  props: ["menu", "parent","userNameType"],
  data() {
    return {
    	loaction: "",
		user:JSON.parse(localStorage.getItem('user'))
    };
  },
  watch: {
		$route(to, from) {
			this.drawerShow(false);
			this.loaction = to.path;
		}
	},
	methods:{
		...Vuex.mapMutations('doctor', ['drawerShow'])
	}
};
</script>

<style scoped>
.title {
  color: #fff;
}
</style>
